// extracted by mini-css-extract-plugin
export var container = "ContentEmbeddedTwoUpGrid-module--container--7dafc";
export var grid = "ContentEmbeddedTwoUpGrid-module--grid--551c7";
export var gridItem = "ContentEmbeddedTwoUpGrid-module--gridItem--07cbc";
export var img = "ContentEmbeddedTwoUpGrid-module--img--86e40";
export var m2Xl = "ContentEmbeddedTwoUpGrid-module--m-2xl--8a246";
export var m2Xs = "ContentEmbeddedTwoUpGrid-module--m-2xs--8b3aa";
export var m3Xl = "ContentEmbeddedTwoUpGrid-module--m-3xl--a26f5";
export var m3Xs = "ContentEmbeddedTwoUpGrid-module--m-3xs--e7460";
export var m4Xl = "ContentEmbeddedTwoUpGrid-module--m-4xl--f6fe2";
export var m5Xl = "ContentEmbeddedTwoUpGrid-module--m-5xl--43f73";
export var m6Xl = "ContentEmbeddedTwoUpGrid-module--m-6xl--a8817";
export var m7Xl = "ContentEmbeddedTwoUpGrid-module--m-7xl--ac46c";
export var m8Xl = "ContentEmbeddedTwoUpGrid-module--m-8xl--a242f";
export var mBase = "ContentEmbeddedTwoUpGrid-module--m-base--ae487";
export var mLg = "ContentEmbeddedTwoUpGrid-module--m-lg--7a8f7";
export var mMd = "ContentEmbeddedTwoUpGrid-module--m-md--b00a5";
export var mSm = "ContentEmbeddedTwoUpGrid-module--m-sm--ceccd";
export var mXl = "ContentEmbeddedTwoUpGrid-module--m-xl--fdeea";
export var mXs = "ContentEmbeddedTwoUpGrid-module--m-xs--45b44";
export var mb2Xl = "ContentEmbeddedTwoUpGrid-module--mb-2xl--c8658";
export var mb2Xs = "ContentEmbeddedTwoUpGrid-module--mb-2xs--1f83b";
export var mb3Xl = "ContentEmbeddedTwoUpGrid-module--mb-3xl--e9d9f";
export var mb3Xs = "ContentEmbeddedTwoUpGrid-module--mb-3xs--bba8b";
export var mb4Xl = "ContentEmbeddedTwoUpGrid-module--mb-4xl--18af2";
export var mb5Xl = "ContentEmbeddedTwoUpGrid-module--mb-5xl--f6d02";
export var mb6Xl = "ContentEmbeddedTwoUpGrid-module--mb-6xl--c766a";
export var mb7Xl = "ContentEmbeddedTwoUpGrid-module--mb-7xl--2a409";
export var mb8Xl = "ContentEmbeddedTwoUpGrid-module--mb-8xl--e84f2";
export var mbBase = "ContentEmbeddedTwoUpGrid-module--mb-base--4b297";
export var mbLg = "ContentEmbeddedTwoUpGrid-module--mb-lg--943f6";
export var mbMd = "ContentEmbeddedTwoUpGrid-module--mb-md--af578";
export var mbSm = "ContentEmbeddedTwoUpGrid-module--mb-sm--6525f";
export var mbXl = "ContentEmbeddedTwoUpGrid-module--mb-xl--3712c";
export var mbXs = "ContentEmbeddedTwoUpGrid-module--mb-xs--31dc3";
export var ml2Xl = "ContentEmbeddedTwoUpGrid-module--ml-2xl--196c0";
export var ml2Xs = "ContentEmbeddedTwoUpGrid-module--ml-2xs--25ced";
export var ml3Xl = "ContentEmbeddedTwoUpGrid-module--ml-3xl--f818c";
export var ml3Xs = "ContentEmbeddedTwoUpGrid-module--ml-3xs--2c3bc";
export var ml4Xl = "ContentEmbeddedTwoUpGrid-module--ml-4xl--853b1";
export var ml5Xl = "ContentEmbeddedTwoUpGrid-module--ml-5xl--22a29";
export var ml6Xl = "ContentEmbeddedTwoUpGrid-module--ml-6xl--e3b74";
export var ml7Xl = "ContentEmbeddedTwoUpGrid-module--ml-7xl--19b0c";
export var ml8Xl = "ContentEmbeddedTwoUpGrid-module--ml-8xl--82a9c";
export var mlBase = "ContentEmbeddedTwoUpGrid-module--ml-base--e7d50";
export var mlLg = "ContentEmbeddedTwoUpGrid-module--ml-lg--d8cb4";
export var mlMd = "ContentEmbeddedTwoUpGrid-module--ml-md--aba40";
export var mlSm = "ContentEmbeddedTwoUpGrid-module--ml-sm--9ba1c";
export var mlXl = "ContentEmbeddedTwoUpGrid-module--ml-xl--008a7";
export var mlXs = "ContentEmbeddedTwoUpGrid-module--ml-xs--3735a";
export var mr2Xl = "ContentEmbeddedTwoUpGrid-module--mr-2xl--d0b6e";
export var mr2Xs = "ContentEmbeddedTwoUpGrid-module--mr-2xs--93d30";
export var mr3Xl = "ContentEmbeddedTwoUpGrid-module--mr-3xl--8007b";
export var mr3Xs = "ContentEmbeddedTwoUpGrid-module--mr-3xs--306a4";
export var mr4Xl = "ContentEmbeddedTwoUpGrid-module--mr-4xl--51890";
export var mr5Xl = "ContentEmbeddedTwoUpGrid-module--mr-5xl--a720e";
export var mr6Xl = "ContentEmbeddedTwoUpGrid-module--mr-6xl--3a942";
export var mr7Xl = "ContentEmbeddedTwoUpGrid-module--mr-7xl--eec35";
export var mr8Xl = "ContentEmbeddedTwoUpGrid-module--mr-8xl--8dde9";
export var mrBase = "ContentEmbeddedTwoUpGrid-module--mr-base--f5c55";
export var mrLg = "ContentEmbeddedTwoUpGrid-module--mr-lg--3e8fd";
export var mrMd = "ContentEmbeddedTwoUpGrid-module--mr-md--e6152";
export var mrSm = "ContentEmbeddedTwoUpGrid-module--mr-sm--dcd8f";
export var mrXl = "ContentEmbeddedTwoUpGrid-module--mr-xl--c2871";
export var mrXs = "ContentEmbeddedTwoUpGrid-module--mr-xs--00921";
export var mt2Xl = "ContentEmbeddedTwoUpGrid-module--mt-2xl--e2cd7";
export var mt2Xs = "ContentEmbeddedTwoUpGrid-module--mt-2xs--6e50e";
export var mt3Xl = "ContentEmbeddedTwoUpGrid-module--mt-3xl--96252";
export var mt3Xs = "ContentEmbeddedTwoUpGrid-module--mt-3xs--2e313";
export var mt4Xl = "ContentEmbeddedTwoUpGrid-module--mt-4xl--2e94b";
export var mt5Xl = "ContentEmbeddedTwoUpGrid-module--mt-5xl--5812f";
export var mt6Xl = "ContentEmbeddedTwoUpGrid-module--mt-6xl--18249";
export var mt7Xl = "ContentEmbeddedTwoUpGrid-module--mt-7xl--22ee2";
export var mt8Xl = "ContentEmbeddedTwoUpGrid-module--mt-8xl--c9140";
export var mtBase = "ContentEmbeddedTwoUpGrid-module--mt-base--a7636";
export var mtLg = "ContentEmbeddedTwoUpGrid-module--mt-lg--fe176";
export var mtMd = "ContentEmbeddedTwoUpGrid-module--mt-md--b21de";
export var mtSm = "ContentEmbeddedTwoUpGrid-module--mt-sm--e1826";
export var mtXl = "ContentEmbeddedTwoUpGrid-module--mt-xl--2724f";
export var mtXs = "ContentEmbeddedTwoUpGrid-module--mt-xs--dd2b3";
export var p2Xl = "ContentEmbeddedTwoUpGrid-module--p-2xl--a92bf";
export var p2Xs = "ContentEmbeddedTwoUpGrid-module--p-2xs--36dc1";
export var p3Xl = "ContentEmbeddedTwoUpGrid-module--p-3xl--c1e95";
export var p3Xs = "ContentEmbeddedTwoUpGrid-module--p-3xs--7b42b";
export var p4Xl = "ContentEmbeddedTwoUpGrid-module--p-4xl--8f453";
export var p5Xl = "ContentEmbeddedTwoUpGrid-module--p-5xl--8e073";
export var p6Xl = "ContentEmbeddedTwoUpGrid-module--p-6xl--b8cdf";
export var p7Xl = "ContentEmbeddedTwoUpGrid-module--p-7xl--fb11c";
export var p8Xl = "ContentEmbeddedTwoUpGrid-module--p-8xl--b3f9d";
export var pBase = "ContentEmbeddedTwoUpGrid-module--p-base--54131";
export var pLg = "ContentEmbeddedTwoUpGrid-module--p-lg--030a4";
export var pMd = "ContentEmbeddedTwoUpGrid-module--p-md--26a68";
export var pSm = "ContentEmbeddedTwoUpGrid-module--p-sm--a5fcf";
export var pXl = "ContentEmbeddedTwoUpGrid-module--p-xl--9123f";
export var pXs = "ContentEmbeddedTwoUpGrid-module--p-xs--f3ff4";
export var paragraph = "ContentEmbeddedTwoUpGrid-module--paragraph--c8660";
export var paragraphSm = "ContentEmbeddedTwoUpGrid-module--paragraph-sm--b38f1";
export var paragraphXs = "ContentEmbeddedTwoUpGrid-module--paragraph-xs--f72a8";
export var pb2Xl = "ContentEmbeddedTwoUpGrid-module--pb-2xl--03a43";
export var pb2Xs = "ContentEmbeddedTwoUpGrid-module--pb-2xs--635a2";
export var pb3Xl = "ContentEmbeddedTwoUpGrid-module--pb-3xl--ecde3";
export var pb3Xs = "ContentEmbeddedTwoUpGrid-module--pb-3xs--dad7a";
export var pb4Xl = "ContentEmbeddedTwoUpGrid-module--pb-4xl--55fa9";
export var pb5Xl = "ContentEmbeddedTwoUpGrid-module--pb-5xl--8f08b";
export var pb6Xl = "ContentEmbeddedTwoUpGrid-module--pb-6xl--85191";
export var pb7Xl = "ContentEmbeddedTwoUpGrid-module--pb-7xl--09612";
export var pb8Xl = "ContentEmbeddedTwoUpGrid-module--pb-8xl--17d30";
export var pbBase = "ContentEmbeddedTwoUpGrid-module--pb-base--86e3b";
export var pbLg = "ContentEmbeddedTwoUpGrid-module--pb-lg--84110";
export var pbMd = "ContentEmbeddedTwoUpGrid-module--pb-md--ec38b";
export var pbSm = "ContentEmbeddedTwoUpGrid-module--pb-sm--56ecd";
export var pbXl = "ContentEmbeddedTwoUpGrid-module--pb-xl--6e645";
export var pbXs = "ContentEmbeddedTwoUpGrid-module--pb-xs--c8d61";
export var pl2Xl = "ContentEmbeddedTwoUpGrid-module--pl-2xl--08237";
export var pl2Xs = "ContentEmbeddedTwoUpGrid-module--pl-2xs--f9737";
export var pl3Xl = "ContentEmbeddedTwoUpGrid-module--pl-3xl--e5ccd";
export var pl3Xs = "ContentEmbeddedTwoUpGrid-module--pl-3xs--d03b7";
export var pl4Xl = "ContentEmbeddedTwoUpGrid-module--pl-4xl--7dfed";
export var pl5Xl = "ContentEmbeddedTwoUpGrid-module--pl-5xl--20999";
export var pl6Xl = "ContentEmbeddedTwoUpGrid-module--pl-6xl--9875c";
export var pl7Xl = "ContentEmbeddedTwoUpGrid-module--pl-7xl--38884";
export var pl8Xl = "ContentEmbeddedTwoUpGrid-module--pl-8xl--6b2a9";
export var plBase = "ContentEmbeddedTwoUpGrid-module--pl-base--ce186";
export var plLg = "ContentEmbeddedTwoUpGrid-module--pl-lg--4a4fe";
export var plMd = "ContentEmbeddedTwoUpGrid-module--pl-md--1df24";
export var plSm = "ContentEmbeddedTwoUpGrid-module--pl-sm--b6dbd";
export var plXl = "ContentEmbeddedTwoUpGrid-module--pl-xl--f5de7";
export var plXs = "ContentEmbeddedTwoUpGrid-module--pl-xs--cdc68";
export var pr2Xl = "ContentEmbeddedTwoUpGrid-module--pr-2xl--ead38";
export var pr2Xs = "ContentEmbeddedTwoUpGrid-module--pr-2xs--dc3cb";
export var pr3Xl = "ContentEmbeddedTwoUpGrid-module--pr-3xl--cb136";
export var pr3Xs = "ContentEmbeddedTwoUpGrid-module--pr-3xs--66c9d";
export var pr4Xl = "ContentEmbeddedTwoUpGrid-module--pr-4xl--258cf";
export var pr5Xl = "ContentEmbeddedTwoUpGrid-module--pr-5xl--fd762";
export var pr6Xl = "ContentEmbeddedTwoUpGrid-module--pr-6xl--a9cd1";
export var pr7Xl = "ContentEmbeddedTwoUpGrid-module--pr-7xl--02d5d";
export var pr8Xl = "ContentEmbeddedTwoUpGrid-module--pr-8xl--e6680";
export var prBase = "ContentEmbeddedTwoUpGrid-module--pr-base--40273";
export var prLg = "ContentEmbeddedTwoUpGrid-module--pr-lg--882af";
export var prMd = "ContentEmbeddedTwoUpGrid-module--pr-md--fc54d";
export var prSm = "ContentEmbeddedTwoUpGrid-module--pr-sm--9893c";
export var prXl = "ContentEmbeddedTwoUpGrid-module--pr-xl--6d00c";
export var prXs = "ContentEmbeddedTwoUpGrid-module--pr-xs--2e42c";
export var pt2Xl = "ContentEmbeddedTwoUpGrid-module--pt-2xl--7fb89";
export var pt2Xs = "ContentEmbeddedTwoUpGrid-module--pt-2xs--89c05";
export var pt3Xl = "ContentEmbeddedTwoUpGrid-module--pt-3xl--a7d9d";
export var pt3Xs = "ContentEmbeddedTwoUpGrid-module--pt-3xs--145db";
export var pt4Xl = "ContentEmbeddedTwoUpGrid-module--pt-4xl--cff0f";
export var pt5Xl = "ContentEmbeddedTwoUpGrid-module--pt-5xl--7da5d";
export var pt6Xl = "ContentEmbeddedTwoUpGrid-module--pt-6xl--beb8e";
export var pt7Xl = "ContentEmbeddedTwoUpGrid-module--pt-7xl--d0a02";
export var pt8Xl = "ContentEmbeddedTwoUpGrid-module--pt-8xl--92f28";
export var ptBase = "ContentEmbeddedTwoUpGrid-module--pt-base--2e7c7";
export var ptLg = "ContentEmbeddedTwoUpGrid-module--pt-lg--673e3";
export var ptMd = "ContentEmbeddedTwoUpGrid-module--pt-md--bb14d";
export var ptSm = "ContentEmbeddedTwoUpGrid-module--pt-sm--95a42";
export var ptXl = "ContentEmbeddedTwoUpGrid-module--pt-xl--1f468";
export var ptXs = "ContentEmbeddedTwoUpGrid-module--pt-xs--fd5c8";
export var radius0 = "ContentEmbeddedTwoUpGrid-module--radius-0--7a0b8";
export var radius2Xl = "ContentEmbeddedTwoUpGrid-module--radius-2xl--d93c2";
export var radiusFull = "ContentEmbeddedTwoUpGrid-module--radius-full--351de";
export var radiusLg = "ContentEmbeddedTwoUpGrid-module--radius-lg--7e6ea";
export var radiusMd = "ContentEmbeddedTwoUpGrid-module--radius-md--fe198";
export var radiusSm = "ContentEmbeddedTwoUpGrid-module--radius-sm--4035e";
export var radiusXl = "ContentEmbeddedTwoUpGrid-module--radius-xl--55230";
export var radiusXs = "ContentEmbeddedTwoUpGrid-module--radius-xs--a4b4f";
export var title = "ContentEmbeddedTwoUpGrid-module--title--6cd05";
export var titleH1 = "ContentEmbeddedTwoUpGrid-module--title-h1--73b6c";
export var titleH1Alt = "ContentEmbeddedTwoUpGrid-module--title-h1--alt--a1ced";
export var titleH2 = "ContentEmbeddedTwoUpGrid-module--title-h2--43b2e";
export var titleH2Alt = "ContentEmbeddedTwoUpGrid-module--title-h2--alt--4e301";
export var titleH3 = "ContentEmbeddedTwoUpGrid-module--title-h3--e5d8f";
export var titleH3Alt = "ContentEmbeddedTwoUpGrid-module--title-h3--alt--6abdf";
export var titleH4 = "ContentEmbeddedTwoUpGrid-module--title-h4--ff57f";
export var titleH4Alt = "ContentEmbeddedTwoUpGrid-module--title-h4--alt--b03e3";
export var titleH5 = "ContentEmbeddedTwoUpGrid-module--title-h5--9dde9";
export var wrapper = "ContentEmbeddedTwoUpGrid-module--wrapper--f12ab";